import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { SystemModule } from '../../types/permissions';

const Settings: React.FC = () => {
  const navigate = useNavigate();
  const { hasAccess } = usePermissions();

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Configurações</h1>
      </div>

      <div className="page-content">
        <div className="settings-grid">
          {hasAccess(SystemModule.USUARIOS) && (
            <div className="settings-card">
              <div className="settings-card-icon">
                <i className="fas fa-user-cog"></i>
              </div>
              <h3>Configurações de Usuário</h3>
              <p>Gerencie permissões e preferências dos usuários</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/configuracoes/usuarios')}
              >
                Gerenciar Usuários
              </button>
            </div>
          )}

          {hasAccess(SystemModule.CONFIG_SISTEMA) && (
            <div className="settings-card">
              <div className="settings-card-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>Configurações do Sistema</h3>
              <p>Ajuste as configurações gerais do sistema</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/configuracoes/sistema')}
              >
                Configurar Sistema
              </button>
            </div>
          )}

          {hasAccess(SystemModule.CONFIG_BACKUP) && (
            <div className="settings-card">
              <div className="settings-card-icon">
                <i className="fas fa-database"></i>
              </div>
              <h3>Backup e Restauração</h3>
              <p>Realize backup e restore dos dados do sistema</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/configuracoes/backup')}
              >
                Gerenciar Backup
              </button>
            </div>
          )}

          {hasAccess(SystemModule.CONFIG_INTEGRACOES) && (
            <div className="settings-card">
              <div className="settings-card-icon">
                <i className="fas fa-plug"></i>
              </div>
              <h3>Integrações</h3>
              <p>Configure integrações com sistemas externos (CTA Smart, etc)</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/configuracoes/integracoes')}
              >
                Gerenciar Integrações
              </button>
            </div>
          )}

          {hasAccess(SystemModule.CONFIG_WHATSAPP) && (
            <div className="settings-card">
              <div className="settings-card-icon">
                <i className="fab fa-whatsapp"></i>
              </div>
              <h3>Conexões WhatsApp</h3>
              <p>Gerencie conexões WhatsApp para notificações automáticas</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/configuracoes/whatsapp')}
              >
                Gerenciar WhatsApp
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
